import { AutogenModelCustomFscHdr, AutogenRowCustomFscHdr } from "./autogen/AutogenModelCustomFscHdr";

export class ModelCustomFscHdr extends AutogenModelCustomFscHdr<RowCustomFscHdr> {
	constructor() {
		super(RowCustomFscHdr);
	}
}

export class RowCustomFscHdr extends AutogenRowCustomFscHdr {
}